import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpeakService {
  speechRecognition: any;
  speechSynthesis: any;
  voices: any[] = [];

  constructor(private zone: NgZone) {
    this.initSpeechSynthesis();
  }

  record(): Observable<string> {
    return new Observable(observer => {
      const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      if (!SpeechRecognition) {
        observer.error('Speech recognition not supported');
        return;
      }

      this.speechRecognition = new SpeechRecognition();
      this.speechRecognition.continuous = true;
      this.speechRecognition.lang = 'en-UK';
      this.speechRecognition.maxAlternatives = 10;

      this.speechRecognition.onresult = (speech: any) => {
        let transcript = speech.results[speech.resultIndex][0].transcript.trim();
        this.zone.run(() => observer.next(transcript));
      };

      this.speechRecognition.onerror = (error:any) => observer.error(error);
      this.speechRecognition.onend = () => observer.complete();

      this.speechRecognition.start();
      console.log('Listening...');
    });
  }

  speak(text: string): Observable<string> {
    return new Observable(observer => {
      if (!this.speechSynthesis) {
        observer.error('Speech synthesis not supported');
        return;
      }

      let utterance = this.getUtterance(text);
      utterance.onstart = () => observer.next(text);
      utterance.onend = () => observer.complete();

      this.speakUtterance(utterance);
    });
  }

  private initSpeechSynthesis() {
    if ('speechSynthesis' in window) {
      this.speechSynthesis = (window as any).speechSynthesis;
      this.initVoices();
    } else {
      console.log('Speech synthesis not supported.');
    }
  }

  private initVoices() {
    return new Promise<void>(resolve => {
      let id = setInterval(() => {
        let voices = this.speechSynthesis.getVoices();
        if (voices.length !== 0) {
          this.voices = voices.filter((voice:any) => voice.lang.startsWith('en'));
          clearInterval(id);
          resolve();
        }
      }, 10);
    });
  }

  private getUtterance(text: string) {
    let voice = this.voices.find(v => v.lang.includes('en')) || this.voices[0];
    let utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = voice;
    return utterance;
  }

  private speakUtterance(utterance: SpeechSynthesisUtterance) {
    this.speechSynthesis.speak(utterance);
  }

  stopRecognition() {
    if (this.speechRecognition) {
      this.speechRecognition.stop();
    }
  }

  stopSpeechSynthesis() {
    if (this.speechSynthesis) {
      this.speechSynthesis.cancel();
    }
  }
}
